import { DOCUMENTS_SIDES } from '../../../../shared/constants';
import { IUserDocument } from '../../../../shared/ts/document';

const requiredDocuments = [
  {
    type: 'identity_document',
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    sides: [DOCUMENTS_SIDES.FRONT],
  },
  {
    type: 'identity_document',
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    sides: [DOCUMENTS_SIDES.REAR],
  },
  {
    label: 'form:fiscalCode',
    type: 'tax_number',
    sides: [DOCUMENTS_SIDES.FRONT],
  },
];

const isMissing = (document: IUserDocument, side: string) => {
  return !document[side as keyof IUserDocument];
};

export const filterMissingUserDocuments = (userDocuments: IUserDocument[]) => {
  const result: {
    label: string;
    fields: { label: string; sideLabel: string | undefined }[];
  } = {
    label: 'translation:documents',
    fields: [],
  };

  requiredDocuments.forEach(requiredDocument => {
    const userDocument = userDocuments.find(
      doc => doc.type === requiredDocument.type,
    );

    if (userDocument) {
      requiredDocument.sides.forEach(side => {
        if (isMissing(userDocument, side)) {
          result.fields.push({
            label: requiredDocument.label,
            sideLabel: requiredDocument.sideLabel,
          });
        }
      });
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      requiredDocument.sides.forEach(__ => {
        result.fields.push({
          label: requiredDocument.label,
          sideLabel: requiredDocument.sideLabel,
        });
      });
    }
  });

  return result;
};
